import {combineReducers} from 'redux'
import edicoesReducer from "./edicoesReducer";

const basicRootReducer = combineReducers({
  edicoes: edicoesReducer
})

export default basicRootReducer;
